import { FC } from 'react';

import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';

import { RHFTextArea } from 'components/RHFTextArea/RHFTextArea';
import { translate } from 'utils';

type Props = {
  isVieworEdit?: boolean;
  isDisabled?: boolean;
  othersName?: string;
};

const ZenClearUltraPreferenceTemplate: FC<Props> = ({
  isVieworEdit = false,
  isDisabled = false,
  othersName = 'ZenClearUltra.others'
}) => {
  const { control } = useFormContext();

  return (
    <div
      className={classNames('space-y-6', {
        'mt-7': !isVieworEdit
      })}
    >
      <Controller
        control={control}
        name={othersName}
        render={() => (
          <RHFTextArea
            title={translate('common.preferences')}
            labelclassName='text-sm mb-2'
            name={othersName}
            autogrow
            inputProps={{
              disabled: isDisabled,
              placeholder: translate('settings.please_type_here')
            }}
            fontClass='text-sm'
            maxgrowHeight={260}
          />
        )}
      />
    </div>
  );
};

export default ZenClearUltraPreferenceTemplate;
